<div class="row files-view" (window:resize)="resize()" #root_div>
  @for (file of imageFiles(); track file.id; let file_index = $index) {
    <div class="col-md-4 col-sm-6 col-four-1440 col-xs-6" [class.attach-invisible]="file_index > 3">
      <div class="attach attach-image" (click)="onFileClick(file)">
        <img src="{{ file.thumbnail }}" />
        @if (!file.canPreview() && !file.isPdf()) {
          <a class="action-file">
            <i class="fa fa-download"></i>
          </a>
        }
        @if (showShadowBox(file_index)) {
          <div class="overlay"></div>
          <p class="number-attach">+{{ imageFiles().length - 3 }}</p>
        }
      </div>
      @if (!showShadowBox(file_index)) {
        <a class="file-name" (click)="onFileClick(file)">{{ file.file_name }}</a>
      }
    </div>
  }
  @for (file of notImageFiles(); track file.id) {
    <div class="col-md-4 col-sm-6 col-four-1440 col-xs-6">
      <div class="attach attach-image" (click)="onFileClick(file)">
        <div class="file-format"><i [ngClass]="file.file_name | fileIconClass"></i></div>
        @if (!file.canPreview() && !file.isPdf()) {
          <a class="action-file">
            <i class="fa fa-download"></i>
          </a>
        }
      </div>
      <a class="file-name" (click)="onFileClick(file)">{{ file.file_name }}</a>
    </div>
  }
  <app-gallery [items]="previewFiles()" #gallery></app-gallery>
</div>
